import { FC } from 'react'
import { UploadedVisualsSection } from '../common/UploadedVisualsSection.component'

import { AssignmentRendererProps } from './AssignmentRenderer.types'
import {
  DetailSection,
  DetailField,
  DetailBooleanField,
  RendererQueryState
} from '../common'
import { useAssignmentDetailDrawerWorkspaceId } from '../AssignmentDetailDrawer.context'
import { useGetAssignmentAIEditingDetails } from 'dataQueries/assignmentDetails.query'
import { useTranslation } from 'react-i18next'

export const AIEditingDetailsRenderer: FC<AssignmentRendererProps> = ({ assignment }) => {
  const { t } = useTranslation(['gallery'])
  const workspaceId = useAssignmentDetailDrawerWorkspaceId()
  const { data, isLoading, isError, refetch } = useGetAssignmentAIEditingDetails(assignment.id, workspaceId)

  return (
    <RendererQueryState assignmentId={assignment.id} isLoading={isLoading} isError={isError} onRetry={refetch}>
      <DetailSection title={t('gallery:assignment_details.ai_editing.overall.title')}>
        <DetailBooleanField
          label={t('gallery:assignment_details.ai_editing.overall.sky_replacement')}
          value={data?.skyReplacement}
        />
        <DetailField
          label={t('gallery:assignment_details.ai_editing.overall.sky_type')}
          value={data?.cloudType ? t(`gallery:assignment_details.ai_editing.cloud_type.${data.cloudType}`) : undefined}
        />
      </DetailSection>

      <UploadedVisualsSection assignmentId={assignment.id} />
    </RendererQueryState>
  )
}
